import { render } from "./Testimonials.vue?vue&type=template&id=f09a62b4"
const script = {}

import exportComponent from "/Users/rguigsaad/Downloads/f&v/ladidate/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__